import { render, staticRenderFns } from "./ClinicDentist.vue?vue&type=template&id=59495d5a&"
import script from "./ClinicDentist.vue?vue&type=script&lang=js&"
export * from "./ClinicDentist.vue?vue&type=script&lang=js&"
import style0 from "./ClinicDentist.vue?vue&type=style&index=0&id=59495d5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports